import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import InputGroup from '../form/input-group';
import SelectGroup from '../form/select-group';
import LocationGroup from '../form/location-group';
import RadioGroup from '../form/radio-group';
import BirthDateGroup from '../form/birth-date-group';
import BirthTimeGroup from '../form/birth-time-group';
import ReadingHeaderPrice from '../reading-header-price';
import ProfilesNav from '../member/profiles/nav';
import ProfilesList from '../member/profiles/list';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { MediaQuery as MQ } from '../../media-query';
import { getBirthDate, getBirthTime, states, months, asComProducts, checkLocationData } from '../../util';
import _ from 'underscore';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = this.clearForm(true);

        if (props.logged_in) {
            props.getProfiles();
        }

        this.report_years = [];
        for (let y = -5; y <= 2; y++) {
            this.report_years.push(dayjs().subtract(y, 'year').format('YYYY'));
        }

        props.cordialInit();
        props.cordialBrowse();

        const teeups = {
            with_current_location: [
                'big-picture-forecast-redux',
                'big-picture-love-forecast-redux',
            ],
            with_gender: [
                'cosmic-profile-report-redux',
                'essential-birth-report-redux',
                'essential-birth-sample',
            ],
            with_report_dates: [
                'big-picture-forecast-redux',
                'big-picture-love-forecast-redux',
            ],
            with_price: [
                'big-picture-forecast-redux',
                'big-picture-love-forecast-redux',
                'essential-birth-report-redux',
                'astrology-compatibility-redux',
                'astrology-compatibility-sample',
                'relationship-potential-redux',
                'love-languages-redux',
                'relationship-dynamics-redux',
            ],
        };

        this.config = {
            current_location: _.contains(teeups.with_current_location, props.upc),
            gender: _.contains(teeups.with_gender, props.upc),
            report_dates: _.contains(teeups.with_report_dates, props.upc),
            price: _.contains(teeups.with_price, props.upc),
            button_text: {
                ['big-picture-forecast-redux']: [
                    'GET MY PROFILE<span class="arrow">▶</span>',
                ],
                ['big-picture-love-forecast-redux']: [
                    'GET MY PROFILE<span class="arrow">▶</span>',
                ],
                ['cosmic-profile-report']: [
                    'GET MY PROFILE<span class="arrow">▶</span>',
                ],
                ['cosmic-profile-report-redux']: [
                    'GET MY PROFILE<span class="arrow">▶</span>',
                ],
                ['essential-birth-report-redux']: [
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['essential-birth-sample']: [
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['astrology-compatibility-redux']: [
                    'ENTER PERSON 2<span class="arrow">▶</span>',
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['astrology-compatibility-sample']: [
                    'ENTER PERSON 2<span class="arrow">▶</span>',
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['relationship-potential-redux']: [
                    'ENTER PERSON 2<span class="arrow">▶</span>',
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['love-languages-redux']: [
                    'ENTER PERSON 2<span class="arrow">▶</span>',
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
                ['relationship-dynamics-redux']: [
                    'ENTER PERSON 2<span class="arrow">▶</span>',
                    'GET MY REPORT<span class="arrow">▶</span>',
                ],
            },
        };

        if (this.config.price) {
            props.requirePrice(props.upc);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.profiles != this.props.profiles) {
            if (!this.props.profiles && (!nextProps.tab || nextProps.tab == 'you')) {
                this.props.userUpdate({ selected_profile: nextProps.profiles[0] });
            }
        }

        if (nextProps.profile != this.props.profile) {
            if (!nextProps.profile) {
                this.clearForm();
            } else {
                this.populateForm(nextProps.profile);
            }
        }

        if (!nextProps.submitting) {
            if (!nextProps.logged_in && this.props.logged_in) {
                this.clearForm();
            } else if (nextProps.logged_in && !this.props.logged_in) {
                this.props.getProfiles();
            }
        }

        if (nextProps.tab != this.props.tab) {
            if (nextProps.tab == 'new' || nextProps.tab == 'friend') {
                this.clearForm();
            }
        }

        if (nextProps.view != this.props.view) {
            this.clearForm();
        }
    }

    render({ logged_in, tab, profile, view, upc, submitting }) {
        const disabled = submitting || (logged_in && tab == 'friend' && !profile);
        const button_text = view && view == 2 ? this.config.button_text[upc][1] : this.config.button_text[upc][0];

        return (
            <astrology-teeup>
                {this.renderAsComHeader()}
                {this.renderProfilesNav()}
                {this.renderProfilesList()}
                {this.renderFriendMessage()}
                {this.renderLogin()}
                <form onSubmit={this.submit} autoComplete='off' className='has-margin-15-top'>
                    <row>
                        <column className='is-12'>
                            <InputGroup
                                type='text'
                                name='birth_name'
                                label='Name:'
                                placeholder='ENTER NAME'
                                value={this.state.birth_name.value}
                                error={this.state.birth_name.error}
                                onInput={this.setFormValues}
                                disabled={disabled}
                            />
                        </column>
                    </row>
                    {this.renderGender(disabled)}
                    <BirthDateGroup
                        name='birth_date'
                        label='Birth Date:'
                        date={this.state.birth_date}
                        month={this.state.birth_date_month}
                        day={this.state.birth_date_day}
                        year={this.state.birth_date_year}
                        onChange={this.setFormValues}
                        disabled={disabled}
                    />
                    <BirthTimeGroup
                        name='birth_time'
                        label='Birth Time:'
                        time={this.state.birth_time}
                        hour={this.state.birth_time_hour}
                        minute={this.state.birth_time_minute}
                        ampm={this.state.birth_time_ampm}
                        onChange={this.setFormValues}
                        disabled={disabled}
                    />
                    <row className='is-wrap'>
                        <column className='is-6 is-12-mobile has-padding-10-right-desktop has-padding-10-right-tablet'>
                            <LocationGroup
                                prefix='birth'
                                label='Birth'
                                onChange={this.setFormValues}
                                data={this.state.birth_location}
                                disabled={disabled}
                            />
                        </column>
                        {this.renderCurrentLocation(disabled)}
                    </row>
                    {this.renderReportDates(disabled)}
                    {this.renderPrice()}
                    <row>
                        <column className='is-12 has-text-center'>
                            <button
                                className='button'
                                onClick={this.submit}
                                disabled={this.props.submitting}
                                dangerouslySetInnerHTML={{
                                    __html: this.props.submitting
                                        ? 'SUBMITTING…'
                                        : button_text,
                                }}
                            />
                            {this.renderFormError()}
                        </column>
                    </row>
                </form>
            </astrology-teeup>
        );
    }

    renderAsComHeader = () => {
        if (this.props.logged_in && _.contains(asComProducts, this.props.product.description.code)) {
            if (this.props.product.view && this.props.product.view == 2) {
                return (
                    <h2 className='fancy-title has-text-center has-margin-30-bottom'>
                        Person 2:<br />
                        Enter THEIR Information
                    </h2>
                );
            }

            return (
                <h2 className='fancy-title has-text-center has-margin-30-bottom'>
                    Person 1:<br />
                    Enter YOUR Information
                </h2>
            );
        }

        return null;
    }

    renderProfilesNav = () => {
        if (this.props.logged_in) {
            return (<ProfilesNav />);
        }

        return null;
    }

    renderProfilesList = () => {
        if (this.props.logged_in) {
            return (<ProfilesList />);
        }

        return null;
    }

    renderFriendMessage = () => {
        if (this.props.logged_in && this.props.tab == 'friend' && !this.props.profile) {
            return (<p className='is-message has-margin-15-top'>Please choose a Friend Profile above.</p>);
        }

        return null;
    }

    renderLogin = () => {
        if (!this.props.logged_in) {
            return (
                <p className='has-text-center'>
                    Already have an account? <a href='#login'>Log In Now</a>
                </p>
            );
        }

        return null;
    }

    renderGender = (disabled) => {
        if (this.config.gender) {
            return (
                <row className='has-margin-20-bottom'>
                    <column className='is-1 is-2-tablet-portrait is-2-mobile is-3-tiny is-aligned-center'>
                        <label>Gender:</label>
                    </column>
                    <column className='is-11 is-10-tablet-portrait is-10-mobile is-9-tiny is-aligned-center'>
                        <RadioGroup
                            name='gender'
                            value='female'
                            checked={this.state.gender.value == 'female'}
                            onChange={this.setFormValues}
                            label='Female'
                            disabled={disabled}
                        />
                        <RadioGroup
                            name='gender'
                            value='male'
                            checked={this.state.gender.value == 'male'}
                            onChange={this.setFormValues}
                            label='Male'
                            disabled={disabled}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderCurrentLocation = (disabled) => {
        if (this.config.current_location) {
            return (
                <column className='is-6 is-12-mobile'>
                    <LocationGroup
                        prefix='current'
                        label='Current'
                        onChange={this.setFormValues}
                        data={this.state.current_location}
                        disabled={disabled}
                    />
                </column>
            );
        }

        return null;
    }

    renderReportDates = (disabled) => {
        if (this.config.report_dates) {
            return (
                <row>
                    <column className='is-6 has-padding-10-right'>
                        <SelectGroup
                            name='report_date_month'
                            label='Start Report Date:'
                            value={this.state.report_date_month.value}
                            placeholder='MONTH'
                            options={months}
                            error={this.state.report_date_month.error}
                            onChange={this.setFormValues}
                            disabled={disabled}
                        />
                    </column>
                    <column className='is-3 is-6-tablet is-6-mobile'>
                        <SelectGroup
                            name='report_date_year'
                            label='&nbsp;'
                            value={this.state.report_date_year.value}
                            placeholder='YEAR'
                            options={this.report_years}
                            error={this.state.report_date_year.error}
                            onChange={this.setFormValues}
                            disabled={disabled}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderPrice = () => {
        if (this.config.price) {
            return (
                <row>
                    <column className='is-12 has-text-center'>
                        <ReadingHeaderPrice />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderFormError = () => {
        if (this.state.formError) {
            return (<p className='is-error has-margin-10-top'>Please check required fields above</p>);
        }

        return null;
    }

    /* eslint-disable complexity */
    setFormValues = (e) => {
        let state = [];

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            if (e.target.type && e.target.type == 'checkbox') {
                if (e.target.checked) {
                    state[e.target.name] = { value: e.target.value, error: false };
                } else {
                    state[e.target.name] = { value: null, error: false };
                }
            } else if (_.contains(['birth_location', 'current_location'], e.target.name)) {
                state[e.target.name] = e.target.value;
            } else {
                state[e.target.name] = { value: e.target.value, error: false };
            }

            if (e.target.name == 'birth_date_month') {
                state.birth_date = {
                    value: getBirthDate(
                        e.target.value,
                        this.state.birth_date_day.value,
                        this.state.birth_date_year.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date_day') {
                state.birth_date = {
                    value: getBirthDate(
                        this.state.birth_date_month.value,
                        e.target.value,
                        this.state.birth_date_year.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date_year') {
                state.birth_date = {
                    value: getBirthDate(
                        this.state.birth_date_month.value,
                        this.state.birth_date_day.value,
                        e.target.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_date') {
                state.birth_date = {
                    value: dayjs(e.target.value).format('YYYY-MM-DD'),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_hour') {
                state.birth_time = {
                    value: getBirthTime(
                        e.target.value,
                        this.state.birth_time_minute.value,
                        this.state.birth_time_ampm.value,
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_minute') {
                state.birth_time = {
                    value: getBirthTime(
                        this.state.birth_time_hour.value,
                        e.target.value,
                        this.state.birth_time_ampm.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time_ampm') {
                state.birth_time = {
                    value: getBirthTime(
                        this.state.birth_time_hour.value,
                        this.state.birth_time_minute.value,
                        e.target.value
                    ),
                    error: false,
                };
            } else if (e.target.name == 'birth_time' && e.target.value == 'unknown') {
                state.birth_time_hour = {
                    value: null,
                    error: false,
                };

                state.birth_time_minute = {
                    value: null,
                    error: false,
                };
            } else if (e.target.name == 'report_date_year') {
                if (!isNaN(parseInt(this.state.report_date_month.value, 10))) {
                    state.report_date = {
                        value: `${e.target.value}-${this.state.report_date_month.value.toString().padStart(2, 0)}`,
                        error: false,
                    };
                }
            } else if (e.target.name == 'report_date_month') {
                if (!isNaN(parseInt(this.state.report_date_year.value, 10))) {
                    state.report_date = {
                        value: `${this.state.report_date_year.value}-${state.report_date_month.value}`,
                        error: false,
                    };
                }
            }

            this.setState(state);
        }
    }

    populateForm = (profile) => {
        const birth_date = dayjs(profile.birth_date, 'YYYY-MM-DD');
        const birth_time = dayjs(profile.birth_time, 'HH:mm');

        if (profile.birth_city && profile.birth_country && !profile.birth_city_id) {
            this.props.getLocation({
                prefix: 'birth',
                city_name: profile.birth_city.toLowerCase().replace(' ', '_'),
                state_name: profile.birth_state.toLowerCase(),
                country_name: profile.birth_country.toLowerCase(),
            });
        } else if (profile.birth_city_id && !profile.birth_country_id) {
            this.props.getLocation({
                prefix: 'birth',
                city_id: profile.birth_city_id,
            });
        }

        if (profile.current_city && profile.current_country && !profile.current_city_id) {
            this.props.getLocation({
                prefix: 'current',
                city_name: profile.current_city.toLowerCase().replace(' ', '_'),
                state_name: profile.current_state.toLowerCase(),
                country_name: profile.current_country.toLowerCase(),
            });
        } else if (profile.current_city_id && !profile.current_country_id) {
            this.props.getLocation({
                prefix: 'current',
                city_id: profile.current_city_id,
            });
        }

        const state = {
            birth_name: {
                value: profile.first_name || null,
                error: null,
            },
            gender: {
                value: profile.gender || 'female',
            },
            birth_date: {
                value: birth_date.isValid() ? birth_date.format('YYYY-MM-DD') : null,
                error: null,
            },
            birth_date_month: {
                value: birth_date.isValid() ? birth_date.format('M') : null,
                error: null,
            },
            birth_date_day: {
                value: birth_date.isValid() ? birth_date.format('D') : null,
                error: null,
            },
            birth_date_year: {
                value: birth_date.isValid() ? birth_date.format('YYYY') : null,
                error: null,
            },
            birth_time: {
                value: profile.birth_time,
                error: null,
            },
            birth_time_hour: {
                value: profile.birth_time ? birth_time.format('h') : null,
                error: null,
            },
            birth_time_minute: {
                value: profile.birth_time ? birth_time.format('mm') : null,
                error: null,
            },
            birth_time_ampm: {
                value: profile.birth_time ? birth_time.format('a') : 'am',
                error: null,
            },
            birth_location: {
                country: {
                    value: profile.birth_country_id,
                    error: false,
                },
                state: {
                    value: profile.birth_state_id,
                    error: false,
                },
                city: {
                    value: profile.birth_city,
                    error: false,
                },
                city_id: {
                    value: profile.birth_city_id,
                },
            },
            current_location: {
                country: {
                    value: profile.current_country_id,
                    error: false,
                },
                state: {
                    value: profile.current_state_id,
                    error: false,
                },
                city: {
                    value: profile.current_city,
                    error: false,
                },
                city_id: {
                    value: profile.current_city_id,
                },
            },
            report_date_month: {
                value: this.state.report_date_month.value,
                error: null,
            },
            report_date_year: {
                value: this.state.report_date_year.value,
                error: null,
            },
            report_date: {
                value: this.state.report_date.value,
                error: null,
            },
        };

        this.setState(state);
    }

    submit = (e) => {
        e.preventDefault();
        this.setState({ formError: false });
        const state = { formError: false };

        if (!this.state.birth_name.value) {
            state.formError = true;
            state.birth_name = {
                value: null,
                error: 'This field is required',
            };
        }

        if (
            !this.state.birth_date.value
            ||
            !this.state.birth_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)
        ) {
            state.formError = true;
            state.birth_date = {
                value: this.state.birth_date.value,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!this.state.birth_date_month.value) {
                    state.birth_date_month = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_day.value) {
                    state.birth_date_day = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_date_year.value) {
                    state.birth_date_year = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            }
        }

        if (!this.state.birth_time.value) {
            state.formError = true;
            state.birth_time = {
                value: null,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!this.state.birth_time_hour.value) {
                    state.birth_time_hour = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.birth_time_minute.value) {
                    state.birth_time_minute = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            }
        }


        state.birth_location = { ...this.state.birth_location };
        if (this.state.birth_location.country.value) {
            if (checkLocationData(this.props.location.birth_states, this.state.birth_location.state.value)) {
                state.formError = true;
                state.birth_location.state = {
                    value: this.state.birth_location.state.value,
                    error: 'This field is required',
                };
            }

            if (this.props.location.birth_cities && !this.state.birth_location.city.value) {
                state.formError = true;
                state.birth_location.city.error = 'This field is required';
            } else if (this.props.location.birth_cities && !this.state.birth_location.city_id.value) {
                state.formError = true;
                state.birth_location.city.error = 'A valid city is required';
            }
        } else {
            state.formError = true;
            state.birth_location.country.error = 'This field is required';
        }

        if (this.config.current_location) {
            state.current_location = { ...this.state.current_location };
            if (this.state.current_location.country.value) {
                if (checkLocationData(this.props.location.current_states, this.state.current_location.state.value)) {
                    state.formError = true;
                    state.current_location.state = {
                        value: this.state.current_location.state.value,
                        error: 'This field is required',
                    };
                }

                if (this.props.location.current_cities && !this.state.current_location.city.value) {
                    state.formError = true;
                    state.current_location.city.error = 'This field is required';
                } else if (this.props.location.current_cities && !this.state.current_location.city_id.value) {
                    state.formError = true;
                    state.current_location.city.error = 'A valid city is required';
                }
            } else {
                state.formError = true;
                state.current_location.country.error = 'This field is required';
            }
        }

        if (this.config.report_dates) {
            if (
                !this.state.report_date.value
                ||
                !this.state.report_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}/)
            ) {
                state.formError = true;
                state.report_date = {
                    value: this.state.report_date.value,
                    error: 'This field is required',
                };

                if (!this.state.report_date_year.value) {
                    state.report_date_year = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!this.state.report_date_month.value) {
                    state.report_date_month = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            } else {
                const report_date_min = dayjs(`${this.report_years[7]}-01`, 'YYYY-MM');
                const report_date_max = dayjs(`${this.report_years[0]}-12`, 'YYYY-MM');
                const report_date = dayjs(this.state.report_date.value, 'YYYY-MM');

                if (report_date.isBefore(report_date_min)) {
                    state.formError = true;
                    state.report_date = {
                        value: this.state.report_date.value,
                        error: `Must be after or equal to ${report_date_min.format('MMMM YYYY')}`,
                    };
                } else if (report_date.isAfter(report_date_max)) {
                    state.formError = true;
                    state.report_date = {
                        value: this.state.report_date.value,
                        error: `Must be before or equal to ${report_date_max.format('MMMM YYYY')}`,
                    };
                }
            }
        }

        if (!state.formError) {
            const prefix = this.props.view && this.props.view == 2 ? 'person_2' : 'person_1';
            const state = this.state; //locking in values, so forced login won't change them

            const birth_state = state.birth_location.country.value == 5022
                ? _.invert(states.USA)[this.props.location.birth_states[state.birth_location.state.value]]
                : null;

            const payload = {
                [`${prefix}_name`]: {
                    first: state.birth_name.value,
                },
                [`${prefix}_birth_date`]: state.birth_date.value,
                [`${prefix}_birth_location`]: {
                    city: state.birth_location.city.value,
                    state: birth_state,
                    country: this.props.location.birth_country.name,
                    city_id: state.birth_location.city_id.value,
                },
            };

            if (this.config.gender) {
                payload.gender = state.gender.value;
            }

            if (state.birth_time.value !== 'unknown') {
                payload[`${prefix}_birth_time`] = state.birth_time.value;
            }

            if (this.config.report_dates) {
                payload.forecast_date = state.report_date.value + '-01';
                payload.forecast_duration = 12;
            }

            if (this.config.current_location) {
                const current_state = state.current_location.country.value == 5022
                    ? _.invert(states.USA)[this.props.location.current_states[state.current_location.state.value]]
                    : null;

                payload[`${prefix}_location`] = {
                    city: state.current_location.city.value,
                    state: current_state,
                    country: this.props.location.current_country.name,
                    city_id: state.current_location.city_id.value,
                };
            }

            this.props.submit(payload);
        } else {
            this.setState({ ...this.state, ...state });
        }
    }
    /* eslint-enable complexity */

    clearForm = (returnState = false) => {
        const state = {
            formError: false,
            birth_name: {
                value: '',
                error: false,
            },
            gender: {
                value: 'female',
            },
            birth_date: {
                value: '',
                error: false,
            },
            birth_date_month: {
                value: null,
                error: false,
            },
            birth_date_day: {
                value: null,
                error: false,
            },
            birth_date_year: {
                value: null,
                error: false,
            },
            birth_time: {
                value: '',
                error: false,
            },
            birth_time_hour: {
                value: null,
                error: false,
            },
            birth_time_minute: {
                value: null,
                error: false,
            },
            birth_time_ampm: {
                value: 'am',
                error: false,
            },
            birth_location: {
                country: {
                    value: null,
                    error: false,
                },
                state: {
                    value: null,
                    error: false,
                },
                city: {
                    value: null,
                    error: false,
                },
                city_id: {
                    value: null,
                },
            },
            current_location: {
                country: {
                    value: null,
                    error: false,
                },
                state: {
                    value: null,
                    error: false,
                },
                city: {
                    value: null,
                    error: false,
                },
                city_id: {
                    value: null,
                },
            },
            report_date_month: {
                value: this.state && this.state.report_date_month && this.state.report_date_month.value,
                error: null,
            },
            report_date_year: {
                value: this.state && this.state.report_date_year && this.state.report_date_year.value,
                error: null,
            },
            report_date: {
                value: this.state && this.state.report_date && this.state.report_date.value,
                error: null,
            },
        };

        if (returnState) {
            return state;
        }

        this.setState(state);
        return null;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    product: state.product,
    profile: state.user && state.user.selected_profile,
    profiles: state.user && state.user.profiles,
    submitting: state.product && state.product.submitting,
    location: state.location,
    tab: state.user && state.user.tab,
    upc: state.product && state.product.description && state.product.description.code,
    price: state.product && state.product.price,
    view: state.product && state.product.view,
});

const mapDispatchToProps = (dispatch) => ({
    requirePrice: (upc) => dispatch({ type: 'price:required', payload: { upc: upc } }),
    submit: (payload) => dispatch({ type: 'report:submit', payload: payload }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    getLocation: (payload) => dispatch({ type: 'product:get-location', payload: payload }),
    cordialInit: () => dispatch({ type: 'cordial:init' }),
    cordialBrowse: () => dispatch({ type: 'cordial:browse' }),
    getProfiles: () => dispatch({ type: 'member:get-profiles' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
